import React from 'react';
import { Button, CircularProgress, Box } from '@mui/material';
import { Upload as UploadIcon } from '@mui/icons-material';
import { useState, useRef } from 'react';

import ExcelJS from 'exceljs';

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { formatProdsSheet } from '../../utils/products-handler';
import { djangoApi } from '../../utils/axios/axios.utils';
import { gerarExcelEDownload } from './excel-export';

const UpdatePlantioInput = () => {
    const [loading, setLoading] = useState(false);
    const MySwal = withReactContent(Swal);
    const fileInputRef = useRef(null);
    const fileInputRefCheckFornId = useRef(null);
    const [isLoading, setIsLoading] = useState(false);
    const [loadingProdsId, setLoadingProdsId] = useState(false);

    const updateProdsData = async (data) => {
        const params = JSON.stringify(data)
        setIsLoading(true)
        try {
            // const res = await djangoApi
            //     .post("products/register_prods/update_prods_quantity_inventory/", params, {
            //         headers: {
            //             Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
            //             "Content-Type": "application/json"
            //         }
            //     })
            const res = await djangoApi
                .post("products/register_prods/save_prods_updated_api/", params, {
                    headers: {
                        Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                        "Content-Type": "application/json"
                    }
                })
            setIsLoading(false)
            return res
        } catch (err) {
            window.alert(err);
            console.log("Erro ao alterar os produtos", err);
            setIsLoading(false)
        } finally {
            // pass
            setIsLoading(false)
        }

    };
    const checkProdsData = async (data) => {
        const params = JSON.stringify(data)
        setLoadingProdsId(true)
        try {
            // const res = await djangoApi
            //     .post("products/register_prods/update_prods_quantity_inventory/", params, {
            //         headers: {
            //             Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
            //             "Content-Type": "application/json"
            //         }
            //     })
            const res = await djangoApi
                .post("products/register_prods/check_prods_supplier_id_lists/", params, {
                    headers: {
                        Authorization: `Token ${process.env.REACT_APP_DJANGO_TOKEN}`,
                        "Content-Type": "application/json"
                    }
                })
            setLoadingProdsId(false)
            return res
        } catch (err) {
            window.alert(err);
            console.log("Erro ao alterar os produtos", err);
            setLoadingProdsId(false)
        } finally {
            // pass
            setLoadingProdsId(false)
        }
    };



    const handleFileChange = async (event) => {
        const file = event.target.files[0];
        if (file) {
            setLoading(true);
            try {
                const workbook = new ExcelJS.Workbook();
                const fileBuffer = await file.arrayBuffer();
                await workbook.xlsx.load(fileBuffer);

                console.log('worksheets', workbook.worksheets);
                const worksheet = workbook.getWorksheet("Planilha1"); // Get the first worksheet
                if (!worksheet) {
                    throw new Error("Worksheet not found. Make sure the file has a sheet at index 1.");
                }

                const rows = [];

                worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
                    const rowData = row.values; // Retrieve each row's values as an array
                    rows.push(rowData);
                });

                // console.log('rows', rows); // Processed data passed to parent component or other handler

                if (fileInputRef.current) {
                    fileInputRef.current.value = "";
                }

                const params = formatProdsSheet(rows)
                const data = await updateProdsData(params)
                console.log('data res here: ', data)
                if (data?.status === 201) {
                    MySwal.fire({
                        title: 'Feito!!',
                        html: `Produtos Atualizados com sucesso!!<br /> 
                        <br/>${data?.data?.sucess_instances?.length > 0 ? 'Produtos Cadastrados: ' + data?.data?.sucess_instances?.length : ''}
                        <br/>${data?.data?.errors?.length > 0 ? 'Produtos Com erro Enviados por email: ' + data?.data?.errors?.length : ''}`,
                        icon: 'info'
                    }).then(() => {
                        // Code to execute after the alert is confirmed
                        // For example, redirect to another page or refresh data
                    })
                }
            } catch (error) {
                console.error("Error reading Excel file:", error);
                if (fileInputRef.current) {
                    fileInputRef.current.value = "";
                }
            } finally {
                setLoading(false);
                if (fileInputRef.current) {
                    fileInputRef.current.value = "";
                }
            }
        }
    };
    const handleCheckProdsFornId = async (event) => {
        const file = event.target.files[0];
        if (file) {
            setLoadingProdsId(true);
            try {
                const workbook = new ExcelJS.Workbook();
                const fileBuffer = await file.arrayBuffer();
                await workbook.xlsx.load(fileBuffer);

                const worksheet = workbook.worksheets[0];
                if (!worksheet) {
                    throw new Error("Worksheet not found. Make sure the file has a sheet named 'Planilha1'.");
                }

                let fornecedorColumnIndex = null;
                const fornecedores = [];

                // Primeiro, identificar o índice da coluna com o título "Código Fornecedor"
                worksheet.getRow(1).eachCell((cell, colNumber) => {
                    if (typeof cell.value === 'string' && cell.value.trim().toLowerCase() === "código fornecedor") {
                        fornecedorColumnIndex = colNumber;
                    }
                });

                if (!fornecedorColumnIndex) {
                    throw new Error("Coluna 'Código Fornecedor' não encontrada na primeira linha.");
                }

                // Agora, coletar os dados da coluna (ignorando o cabeçalho)
                worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
                    if (rowNumber === 1) return; // pula o cabeçalho
                    const cellValue = row.getCell(fornecedorColumnIndex).value;
                    if (cellValue !== null && cellValue !== undefined && cellValue !== '') {
                        fornecedores.push(cellValue.toString().trim());
                    }
                });

                console.log(fornecedores); // Aqui está a lista final de todos os valores da coluna "Código Fornecedor"

                const data = await checkProdsData(fornecedores)
                console.log('data res here: ', data.data.data)
                if (data?.status === 200 && Array.isArray(data.data.data)) {
                    gerarExcelEDownload(data.data.data)
                    MySwal.fire({
                        title: 'Feito!!',
                        html: `Produtos Atualizados com sucesso!!<br /> 
                        <br/>${data?.data?.data?.length > 0 && 'Produtos Encontrados: ' + data?.data?.data?.length}`,
                        icon: 'info'
                    }).then(() => {
                        // Code to execute after the alert is confirmed
                        // For example, redirect to another page or refresh data
                    })
                }
            } catch (error) {
                console.error("Error reading Excel file:", error);
                if (fileInputRefCheckFornId.current) {
                    fileInputRefCheckFornId.current.value = "";
                }
            } finally {
                setLoadingProdsId(false);
                if (fileInputRefCheckFornId.current) {
                    fileInputRefCheckFornId.current.value = "";
                }
            }
        }
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '20px'
            }}
        >
            <Button
                variant="contained"
                component="label"
                color="inherit"
                style={{ textTransform: 'none', minWidth: '120px', color: 'black' }}
                startIcon={!loading ? <UploadIcon /> : null}
            >
                {loading ? <CircularProgress size={24} color="inherit" /> : "Atualizar Produtos"}
                <input
                    type="file"
                    accept=".xls,.xlsx"
                    hidden
                    ref={fileInputRef}
                    onChange={handleFileChange}
                />
            </Button>
            <Button
                variant="contained"
                component="label"
                color="info"
                style={{ textTransform: 'none', minWidth: '120px', color: 'black' }}
                startIcon={!loadingProdsId ? <UploadIcon /> : null}
            >
                {loadingProdsId ? <CircularProgress size={24} color="inherit" /> : "Consultar ID Forn"}
                <input
                    type="file"
                    accept=".xls,.xlsx"
                    hidden
                    ref={fileInputRefCheckFornId}
                    onChange={handleCheckProdsFornId}
                />
            </Button>
        </Box>
    );
}

export default UpdatePlantioInput;

